import React from "react";
import { CPSettingsBlockWrapper, SettingsBlockHeader, SettingsBlockTitle } from "pages/settings/settingsPageStyles";
import { GreenPlusIcon } from "assets/images";

interface AddConfigBlockProps {
    onClick: () => void;
}

const AddConfigBlock: React.FC<AddConfigBlockProps> = ({ onClick }) => {
    return (
        <CPSettingsBlockWrapper style={{ cursor: "pointer" }} onClick={onClick}>
            <SettingsBlockHeader>
                <SettingsBlockTitle>Добавить конфиг</SettingsBlockTitle>
            </SettingsBlockHeader>

            <div style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#f6ffed",
                border: "2px dashed #52c41a",
                borderRadius: "0 0 8px 8px"
            }}>
                <GreenPlusIcon style={{ width: "80px", height: "80px",margin:"200px 0" }} />
            </div>
        </CPSettingsBlockWrapper>
    );
};

export default AddConfigBlock;